// Menu & UI Colors Constants
export const MENU_COLORS = {
  // Trạng thái bình thường (chưa click, có thể click)
  NORMAL: "#aac8f3",
  NORMAL_HOVER: "#9ab8e3",

  // Trạng thái active (đã click/selected)
  ACTIVE: "#1890ff",
  ACTIVE_HOVER: "#1677cc",

  // Trạng thái disabled/greyed out
  DISABLED: "#e7e7e7",
  DISABLED_HOVER: "#c4c4c4",

  // Text colors
  TEXT_WHITE: "#ffffff",
  TEXT_NAVY: "#000E96",

  // primary color
  PRIMARY: "#174a83",
  DELETE_ALL: "#ffb6b4",
  NORMAL_DELETE: "#df080b",
  DELETE_HOVER: "#f67474",
  DELETE_DISABLED: "#ffd6d6",

  //
  MISSING_REQUIRE: "#9b59b6",
  MISSING_REQUIRE_HOVER: "#8e44ad",

  // disabled button
  DISABLED_BUTTON: "#bcbcbc",
};

export const SIDEBAR_COLORS = {
  TEXT_DEFAULT: "#333333",
  TEXT_ACTIVE: "#1e3665",
  TEXT_DISABLED: "#9ca3af",
  BORDER_ACTIVE: "#1e3665",
  CUSTOMER_BG: "#d9dde5",
  CUSTOMER_BORDER: "#d9dde5",
};
